import { SvgIconComponent } from '@mui/icons-material'
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import { PaletteColor, Theme } from '@mui/material'

import { TooltipProps } from './types'

export const chooseIcon = (
  props: TooltipProps,
): { component: SvgIconComponent; dataCy: string } => {
  const { variant } = props

  switch (variant) {
    case 'custom': {
      return {
        component: props.customIcon.icon,
        dataCy: props.customIcon.iconDataCy,
      }
    }
    case 'error':
      return {
        component: ErrorOutlineOutlinedIcon,
        dataCy: 'error-outline-outlined-icon',
      }
    case 'help':
      return {
        component: HelpOutlineOutlinedIcon,
        dataCy: 'help-outline-outlined-icon',
      }
    default:
      return {
        component: HelpOutlineOutlinedIcon,
        dataCy: 'help-outline-outlined-icon',
      }
  }
}

export const chooseIconColor = ({
  props,
  theme,
}: {
  props: TooltipProps
  theme: Theme
}): PaletteColor['main'] => {
  const { variant } = props

  const helpColor: PaletteColor['main'] = theme.palette.grey[400]

  switch (variant) {
    case 'custom': {
      return props.customIcon.color || theme.palette.black.main
    }
    case 'error':
      return theme.palette.error.main
    case 'help':
      return helpColor
    default:
      return helpColor
  }
}
